firebird.controller('changeBrowserCtrl', [
    '$stateParams',
    'logService',
    'helperService',
    function ($stateParams, logService, helperService) {
        const logger = logService.createLoggerWithSource('changeBrowserCtrl');
        var self = this;

        self.meetingLinkWithParam = '';

        init();

        ////////////////////////

        function init() {
            logger.debug('init changeBrowserCtrl');

            var host = helperService.getLocationHost().toLowerCase();
            self.meetingLinkWithParam = host + '/' + $stateParams.meetingCode;
            self.meetingLinkWithParam += $stateParams.presenterGUID ? '?rslt=' + $stateParams.presenterGUID : '';
        }
    }
]);
